import React from "react";

import { Typography } from "@material-ui/core";

const LastStep = () => {
  return (
    <Typography variant="body2" color="textSecondary">
      To get going, we recommend you spend some time looking through all the
      information your team&apos;s already captured. This includes all the
      research, ideas & experiments.
    </Typography>
  );
};

export default React.memo(LastStep);
